export default {
  allNotifications: [],
}
